const configViews = ['goFastMail', 'allServicePoint', 'fee/pay', 'express/list']
const sendViews = ['express/list', 'letterSetting']
const nogzhViews = ['download', 'sms/index', 'report', 'location']
function checkConfig(url) {
  // 不需要wx.config的页面会返回true
  let result = true
  for (let i in configViews) {
    if (url.includes(configViews[i])) {
      result = false
      break
    }
  }
  return result
}
function checkSend(url) {
  // 不是寄件内容   的页面会返回true
  let result = true
  for (let i in sendViews) {
    if (url.includes(sendViews[i])) {
      result = false
      break
    }
  }
  return result
}
function noCheck(url) {
  // 不用从公众号打开的页面  返回false
  let result = true
  for (let i in nogzhViews) {
    if (url.includes(nogzhViews[i])) {
      result = false
      break
    }
  }
  return result
}
export { checkConfig, checkSend, noCheck }
